import { render, staticRenderFns } from "./LoanItem.vue?vue&type=template&id=15a0535e&scoped=true&"
import script from "./LoanItem.vue?vue&type=script&lang=js&"
export * from "./LoanItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=15a0535e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0535e",
  null
  
)

export default component.exports